// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseTooltip-wrapper-2ieCQ_DEky","text":"BaseTooltip-text-1D-AaDiKuw","icon":"BaseTooltip-icon-H3WUkDKzKk color-midtone-1b38Xj_mpm"};